import { gql } from '@urql/core';

export const CREATE_DIRECTORY_MUTATION = gql`
    mutation CreateDirectory($input: CreateDirectoryInput!) {
        createDirectory(input: $input) {
            directory {
                id
            }
        }
    }
`;

export const UPDATE_DIRECTORY_MUTATION = gql`
    mutation UpdateDirectory($input: UpdateDirectoryInput!) {
        updateDirectory(input: $input) {
            directory {
                id
                name
            }
        }
    }
`;

export const CREATE_DIRECTORY_FILE_MUTATION = gql`
    mutation CreateDirectoryFile($input: CreateFileInput!) {
        createFile(input: $input) {
            file {
                id
            }
        }
    }
`;

export const DELETE_DIRECTORY_MUTATION = gql`
    mutation DeleteDirectory($input: DeleteDirectoryInput!) {
        deleteDirectory(input: $input) {
            success
        }
    }
`;

export const DELETE_DIRECTORY_FILE_MUTATION = gql`
    mutation DeleteDirectoryFile($input: DeleteFileInput!) {
        deleteFile(input: $input) {
            success
        }
    }
`;

export const UPDATE_FILE_MUTATION = gql`
    mutation UpdateDirectoryFile($input: UpdateFileInput!) {
        updateFile(input: $input) {
            file {
                id
                name
            }
        }
    }
`;

export const ARCHIVE_DIRECTORY_MUTATION = gql`
    mutation ArchiveDirectory($input: ArchiveDirectoryInput!) {
        archiveDirectory(input: $input) {
            key
        }
    }
`;
